import React, { useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentWizardData } from "../../../../../../../redux/actions/wizardActions";

const WizardCustomHeaderAuth = () => {
  const currentData = useSelector((state) => state.wizard.currentData);
  const dispatch = useDispatch();

  const onChange = (fieldName) => (e) => {
    const updatedData = {
      ...currentData,
      [fieldName]: e.target.value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  return (
    <div>
      <p>Enter the token to access Oktas API</p>
      Okta token:
      <Textfield
        name="oktaToken"
        value={
          currentData?.oktaToken ? currentData?.oktaToken : ""
        }
        onChange={onChange("oktaToken")}
        type="password"
      />
      Steps to get the Token:
      <ol>
        <li>Open okta admin UI, navigate to Security - API</li>
        <li>Click on Token tab</li>
        <li>Click Create Token</li>
      </ol>
    </div>
  );
};

export default WizardCustomHeaderAuth;
